import React from 'react';
import classes from "./Advantage.module.css"
import img1 from "./../../Assest/wcu1.png"
import img2 from "./../../Assest/wcu2.png"
import img3 from "./../../Assest/wcu3.png"
import img4 from "./../../Assest/wcu4.png"
import img5 from "./../../Assest/wcu5.png"
import img6 from "./../../Assest/wcu6.png"
import img7 from "./../../Assest/wcu7.png"
import img8 from "./../../Assest/wcu8.png"
import Fade from 'react-reveal/Fade';


const Advantage = () => {
  return (
    <div>

          <h2 className={classes.ih3h}>WHAT WE PROVIDE</h2>

<div className={classes.Adv}>

<div className={classes.Adv1}>
  <Fade left>
  <div className={classes.set}> <h3 className={classes.set1}>Honest & Transparent Guidance</h3> <img src={img1} className={classes.seti}/></div>
    <div className={classes.set}> <h3 className={classes.set1}>Student-First Approach</h3> <img src={img2} className={classes.seti}/></div>
     <div className={classes.set}> <h3 className={classes.set1}>End-to-End Counselling Support</h3> <img src={img3} className={classes.seti}/></div>
      <div className={classes.set}> <h3 className={classes.set1}>Complete Technical Assistance for Application</h3> <img src={img4} className={classes.seti}/></div>
      
</Fade>

</div>

<div className={classes.Adv2}>
   <Fade right>
   <div className={classes.set}> <img src={img5} className={classes.seti}/> <h3 className={classes.set1}>Realistic Options Based on Marks & Budget</h3> </div>
    <div className={classes.set}> <img src={img6} className={classes.seti}/> <h3 className={classes.set1}>Personal Attention to Every Student</h3> </div>
     <div className={classes.set}> <img src={img7}className={classes.seti}/> <h3 className={classes.set1}>Strong Network with Colleges & Institutes</h3> </div>
         <div className={classes.set}> <img src={img8}className={classes.seti}/> <h3 className={classes.set1}>Dedicated Parent Counselling Support</h3> </div>
</Fade>
</div>



</div>


    </div>
  )
}

export default Advantage